<script>
export default {
	name: 'ReportManageFormButtons',
	props: {
		edit: {
			type: Boolean,
			default: true,
		},
		report: {
			type: String,
			default: '',
		},
		signStatus: {
			type: Boolean,
			default: false,
		},
		showButtons: {
			type: Boolean,
			default: true,
		},
		onSave: {
			type: Function,
			default: null,
		},
	},
	emits: ['save'],
	computed: {
		getReportEditLink() {
			if (!this.report) return ''
			return `/${this.$i18n.locale}/account/reporting/${this.report}/${this.$route.params.id}/edit`
		},
	},
}
</script>

<template>
	<div class="reporting-btn" v-if="showButtons">
		<div class="reporting-wrapper">
			<template v-if="edit">
				<button
					type="button"
					class="input-btn form__line--btn"
					@click="onSave ? onSave() : $emit('save')"
				>
					{{ $t('button.save') }}
				</button>
			</template>
			<template v-else-if="!signStatus">
				<a class="input-btn form__line--btn" @click.prevent="$modal.show('ReportManageModal')">
					{{ $t('button.ecp') }}
				</a>
				<router-link
					v-if="getReportEditLink"
					:to="getReportEditLink"
					class="input-btn form__line--btn form__line--btn-black"
				>
					{{ $t('button.edit') }}
				</router-link>
			</template>
			<template v-else>
				<span class="input-btn form__line--btn form__line--disabled"> Подписан </span>
				<router-link
					v-if="getReportEditLink"
					:to="getReportEditLink"
					class="input-btn form__line--btn form__line--btn-black"
				>
					{{ $t('button.edit') }}
				</router-link>
			</template>
		</div>
	</div>
</template>
